import { colors } from 'fitify-ui'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { useTranslation } from 'next-i18next'

import { type ExerciseItem, getExercisePopularity } from '@/utils/exercises'

import {
  StyledBar,
  StyledBarChart,
  StyledPopularityCard,
  StyledPopularityLabel,
  StyledPopularityLeft,
  StyledPopularityRight,
  StyledPopularityValue,
} from './PopularityCard.Styled'
import { formatCount } from './PopularityCard.Utils'

type Props = {
  exercise: ExerciseItem
}

export const PopularityCard = ({ exercise }: Props) => {
  const { t } = useTranslation()

  const popularity = getExercisePopularity(exercise)
  const maxCount = Math.max(...popularity.last8w)
  const barHeights = popularity.last8w.map((v) =>
    maxCount > 0 ? Math.round((v / maxCount) * 100) : 50
  )

  return (
    <StyledPopularityCard>
      <StyledPopularityLeft>
        <StyledPopularityLabel $isTrendUp={popularity.isTrendUp}>
          {t('landing_exercises_popularity')}
        </StyledPopularityLabel>
        <StyledPopularityValue>
          <Typography
            $color={colors.Black}
            $variant="Headline/H 24 Bold"
            $variantPhone="Headline/H 20 Bold"
          >
            {formatCount(popularity.count)}
          </Typography>
          <Typography $color={colors.Gray600} $variant="Text/Body 12">
            {t('landing_exercises_tracked_this_week')}
          </Typography>
        </StyledPopularityValue>
      </StyledPopularityLeft>
      <StyledPopularityRight>
        <StyledBarChart>
          {barHeights.map((height, index) => (
            <StyledBar
              key={index}
              $height={height}
              $index={index}
              $isTrendUp={popularity.isTrendUp}
            />
          ))}
        </StyledBarChart>
        <Typography $color={colors.Gray500} $variant="Text/Body 10">
          {t('landing_exercises_last_8_weeks')}
        </Typography>
      </StyledPopularityRight>
    </StyledPopularityCard>
  )
}
